import { types } from 'mobx-state-tree';

import { localStorageService } from '@trader/services';
import { LOCAL_STORAGE_KEYS } from '@trader/constants';
import { runInAction } from '@trader/utils';
import { ETradingView } from '@trader/types';
import { EThemes } from '@trader/themes';

const AppStore = types
  .model('AppStore', {
    themeMode: types.union(
      types.literal(EThemes.Light),
      types.literal(EThemes.Dark)
    ),
    chartType: types.union(
      types.literal(ETradingView.Advanced),
      types.literal(ETradingView.Classic)
    ),
  })
  .actions(store => ({
    runInAction,
    toggleThemeMode: (value?: EThemes) => {
      const theme =
        store.themeMode === EThemes.Light ? EThemes.Light : EThemes.Dark;

      store.themeMode = value || theme;
      localStorageService.set(LOCAL_STORAGE_KEYS.theme, value || theme);
    },
    changeChartType: (value: ETradingView) => {
      store.chartType = value;
    },
  }));

export const app = types.optional(AppStore, {
  themeMode: EThemes.Light,
  chartType: ETradingView.Advanced,
});
